// opervex-frontend/src/components/Financial/ClearingModalService.js
let openModal = null;

const ClearingModalService = (options = {}) => {
  if (!openModal) {
    return Promise.resolve(null);
  }

  return openModal(options);
};

ClearingModalService.register = (handler) => {
  openModal = handler;
};

ClearingModalService.unregister = () => {
  openModal = null;
};

export { ClearingModalService as ClearingModal };
export default ClearingModalService;
